import {FormSanctionModel} from './FormSanctionModel';

export class FormAlcoolemieModel {

  nombreControlesPositifsAlcoolemie36DerniersMois: number;
  dateDernierAlcoolemie36DerniersMois: string;
  controleAlcoolemieSuiteA36DerniersMois: string;
  controleAlcoolemieMethode36DerniersMois: string;
  isRefusTestAlcoolemie36DerniersMois: string;
  tauxAlcoolemie: number;
  isDelitDeFuiteAlcoolemie36DerniersMois: string;
  isAnnulationOuSuspensionPermis36DerniersMois: string;
  sanction: FormSanctionModel;

  constructor() {
    this.sanction = new FormSanctionModel();
  }
}
